import React, { useState, useEffect } from "react";
import { Checkbox } from "antd";
import { CaretUpOutlined, CaretDownOutlined } from "@ant-design/icons";
import "./style.css";

const CustomFilter = ({ filterOptions, filterBy, setFilterBy }) => {
  const [hiddenFilters, setHiddenFilters] = useState([]);
  const [checkedFilters, setCheckedFilters] = useState([]);

  useEffect(() => {}, [checkedFilters]);

  const handleHideFilter = (id) => {
    const newHiddenFilters = [...hiddenFilters];
    if (hiddenFilters.includes(id)) {
      newHiddenFilters.splice(newHiddenFilters.indexOf(id), 1);
    } else {
      newHiddenFilters.push(id);
    }
    setHiddenFilters(newHiddenFilters);
  };


  const onFilterChange = (val) => {
    const isEmpty =
      Object.values(val)[0] !== null && Object.values(val)[0] !== ""
        ? false
        : true;
    const currentFilters = { ...filterBy };
    if (isEmpty) {
      const emptyObj = Object.keys(val)[0];
      delete currentFilters[emptyObj];
      setFilterBy(currentFilters);
    } else {
      setFilterBy({ ...filterBy, ...val });
    }
  };

  return (
    <div className="card-border filter-container shadow p-3 mt-3">
      <div className="d-flex justify-content-between">
        <label>Filter by:</label>
        <label
          className="text-gray cursor-pointer sm-label"
          onClick={() => {
            window.location.reload();
          }}
        >
          Clear all
        </label>
      </div>
      {filterOptions.length
        ? filterOptions.map((option) => {
            const { multiple } = option;
            let selectedMultiples = [];
            return (
              <div key={option.id} on className={`filter-option-container my-3`}>
                <div className="d-flex justify-content-between text-bold cursor-pointer">
                  <span style={{fontWeight: "bold"}}>{option.title}</span>
                  <span onClick={() => handleHideFilter(option.id)}>
                    {hiddenFilters.includes(option.id) ? (
                      <CaretDownOutlined />
                    ) : (
                      <CaretUpOutlined />
                    )}
                  </span>
                </div>
                <div
                  className={`${
                    hiddenFilters.includes(option.id) && "hide-filter"
                  } `}
                >
                  {option.filters?.map((filter, index) => (
                    <>
                      <Checkbox
                        key={filter.id}
                        value={filter.value}
                        checked={
                          multiple
                            ? checkedFilters.some((f) => {
                                return f[option.value] === filter.value;
                              })
                            : filter.value === checkedFilters[option.value]
                        }
                        onChange={(e) => {
                          const isChecked = e.target.checked;
                          const val = isChecked ? filter.value : "";

                          // if multiple enabled send array of values
                          if (multiple) {
                            if (isChecked) {
                              setCheckedFilters([
                                ...checkedFilters,
                                { [option.value]: val },
                              ]);
                            } else {
                              setCheckedFilters((prev) => {
                                return prev.filter(
                                  (f) => f[option.value] !== filter.value
                                );
                              });
                            }
                            const selectedChoices = {
                              [option.value]: checkedFilters.map(
                                (f) => Object.values(f)[0]
                              ),
                            };

                            selectedMultiples.push(val);

                            return onFilterChange(selectedChoices);
                          } else {
                            // otherwise, send only the selected
                            setCheckedFilters({
                              ...checkedFilters,
                              [option.value]: val,
                            });

                            return onFilterChange({ [option.value]: val });
                          }
                        }}
                      >
                        {filter.name}
                      </Checkbox>
                      <br />
                    </>
                  ))}
                  {/* </Checkbox.Group> */}
                </div>
              </div>
            );
          })
        : null}
    </div>
  );
};


export default CustomFilter;
